import { ProductData, WithContext } from "../types/schema.types";
import type { Product } from "schema-dts";
import { generateProduct } from "../utils/schema-generators";

/**
 * Builds Schema.org Product structured data
 * @param productData - Product information for schema generation
 * @returns Schema.org Product JSON-LD object
 */
export function buildProductSchema(
  productData: ProductData
): WithContext<Product> {
  const productSchema: WithContext<Product> = {
    "@context": "https://schema.org",
    ...generateProduct(productData),
  };

  return productSchema;
}
